import React from 'react'
import { ChartQuestionOption } from 'hooks/reports'
import { Wrapper } from './styled'

interface Props {
  options: ChartQuestionOption[]
  showNumbers: boolean
  isPDF: boolean
}

export const Recommendations = ({ options, showNumbers, isPDF }: Props) => {
  return (
    <Wrapper isPDF={isPDF}>
      <>
        <div>Survey Answer</div>
        {isPDF && (
          <div className='response'>Responses</div>
        )}
        <div>Recommendation</div>
      </>
      {options.map((option, i) => {
        const {
          option_label: label,
          recommendation,
          parent_id: parentId,
          selected_by: responses
        } = option
        const optionNumber = `${i + 1}.`

        if (parentId > 0) {
          return false
        }

        return (
          <React.Fragment key={i}>
            <div>{showNumbers && optionNumber} {label}</div>
            {isPDF && (
              <div className='response'>{responses}</div>
            )}
            <div>{recommendation}</div>
          </React.Fragment>
        )
      })}
    </Wrapper>
  )
}
